/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { ComponentClassNames, mergeStyleSets } from "@microsoft/shifts-ui-core";

type ClassNames =
    | "cell"
    | "cellZeroCount"
    | "contentCell"
    | "scheduleGroupPeopleCountRow"
    | "scheduleGroupPeopleCountRowCell"
    | "text"
    | "title"
    | "titleCell";

/**
 * Gets the 'ScheduleGroupPeopleCountRow' component CSS class names.
 * @returns The 'ScheduleGroupPeopleCountRow' component CSS class names.
 */
export const getClassNames = (): ComponentClassNames<ClassNames> => {
    // TODO: Use 'Theme' from Fluent instead of CSS variables.
    const backgroundColor = "var(--app-gray-10)";
    const borderColor = "var(--app-gray-09)";
    const cellBorderTop = "var(--app-grid-selection)";
    const cellZeroCountOpacity = "var(--subtle-text-opacity)";
    const textColor = "var(--app-faded-black)";
    const titleColor = "var(--app-faded-black)";

    return mergeStyleSets({
        cell: {
            // This adds the right border to separate each day in 'Week' view 'Staff per 6 hours'
            "&:nth-child(4n+1)": {
                borderRight: `0.0625rem solid ${borderColor}`
            },
            alignItems: "center",
            color: textColor,
            display: "flex",
            justifyContent: "center",
            height: "1.625rem",
            width: "100%"
        },
        cellZeroCount: {
            opacity: cellZeroCountOpacity
        },
        contentCell: {
            borderTop: `0.0625rem solid ${borderColor}`
        },
        scheduleGroupPeopleCountRow: {
            height: "1.625rem"
        },
        scheduleGroupPeopleCountRowCell: {
            color: textColor,
            // TODO: Remove !important
            height: "1.625rem !important",
            width: "100%"
        },
        text: {
            borderTop: `0.125rem solid ${cellBorderTop}`,
            color: textColor,
            fontSize: "0.65rem",
            textAlign: "center",
            width: "50%"
        },
        title: {
            color: titleColor
        },
        titleCell: {
            borderTop: `0.0625rem solid ${backgroundColor}`,
            backgroundColor,
            color: titleColor,
            justifyContent: "flex-start",
            minWidth: "10rem",
            paddingLeft: "1.25rem"
        }
    });
};
